import React from 'react';
import PropTypes from 'prop-types';
import {
  classifierGeneralField,
  classifierSubValuesItemField,
  classifierGeneralItemLangField,
} from '../../constants/classifier';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Table, Button, Popconfirm } from 'antd';
import { TableRowActions } from '../';

const ClassifierSubValuesTable = ({
  dataSource,
  t,
  showModal,
  deleteClassifier,
}) => {
  const getColumns = () => {
    const columns = [
      {
        title: t('tableGeneral.code'),
        dataIndex: classifierSubValuesItemField.CODE,
      },
    ];
    if (dataSource.code === 'FEEDSTOCK') {
      columns.push({
        title: t('tableGeneral.aibCode'),
        dataIndex: classifierSubValuesItemField.AIB_CODE,
      });
    }
    columns.push(
      {
        title: t('tableGeneral.en'),
        dataIndex: [
          classifierSubValuesItemField.LANG,
          classifierGeneralItemLangField.EN,
        ],
      },
      {
        title: t('tableGeneral.et'),
        dataIndex: [
          classifierSubValuesItemField.LANG,
          classifierGeneralItemLangField.ET,
        ],
      },
      {
        title: t('tableGeneral.actions'),
        render: (value) => (
          <TableRowActions>
            <Button
              shape="circle"
              icon={<EditOutlined />}
              size="small"
              type="primary"
              onClick={() =>
                showModal(value[classifierSubValuesItemField.CODE])
              }
            />
            <span className="ant-divider" />
            <Popconfirm
              title={t('popconfirm.title')}
              onConfirm={() =>
                deleteClassifier(value[classifierSubValuesItemField.CODE])
              }
              okText={t('popconfirm.buttonYes')}
              cancelText={t('popconfirm.buttonNo')}
            >
              <Button
                shape="circle"
                icon={<DeleteOutlined />}
                size="small"
                type="primary"
              />
            </Popconfirm>
          </TableRowActions>
        ),
      }
    );

    return columns;
  };

  return (
    <>
      <h1>{dataSource[classifierGeneralField.TITLE]}</h1>
      <Table
        rowKey={classifierSubValuesItemField.CODE}
        dataSource={dataSource[classifierGeneralField.ITEMS]}
        columns={getColumns()}
        pagination={false}
      />
    </>
  );
};

ClassifierSubValuesTable.propTypes = {
  dataSource: PropTypes.object,
  t: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  deleteClassifier: PropTypes.func.isRequired,
};

export default ClassifierSubValuesTable;
